module.exports = __webpack_public_path__ + "img/in-capm.e0265c38.png";